import { Typography } from '@material-ui/core';
import { FormikTextField } from '@superdispatch/forms';
import { Column, Columns, Stack } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';

export const SUBSCRIPTION_CONTACT_DESCRIPTION =
  'Gets invoices, receipts, failed payments, and cancellation notices.';

interface SubscriptionContactFieldsProps {
  hasTitle?: boolean;
}

export function SubscriptionContactFields({
  hasTitle,
}: SubscriptionContactFieldsProps) {
  return (
    <Stack space="small">
      <Stack space="xxsmall">
        {hasTitle && <Typography variant="h3">Subscription Contact</Typography>}
        <TextBox color="secondary" variant="body">
          {SUBSCRIPTION_CONTACT_DESCRIPTION}
        </TextBox>
      </Stack>

      <Columns space="small" collapseBelow="tablet">
        <Column width="1/2">
          <FormikTextField
            name="contact_first_name"
            label="First Name"
            fullWidth={true}
          />
        </Column>
        <Column width="1/2">
          <FormikTextField
            name="contact_last_name"
            label="Last Name"
            fullWidth={true}
          />
        </Column>
      </Columns>

      <FormikTextField
        name="contact_email"
        label="Email"
        type="email"
        fullWidth={true}
      />
    </Stack>
  );
}
